import { createStore } from 'vuex';

import { SplitVuexModule } from '@smg-real-estate/vue-experiments';
import favourites from './modules/favourites';

const store = createStore({
  modules: {
    favourites,
    split: SplitVuexModule,
  },
});

export default store;
